import { Link } from "react-router";
import { cn } from "@/utils/css";
import { isModifiedClick } from "@/utils/click";

// Always a link so middle-click / Cmd-click opens the route in a new browser tab.
// Plain left clicks are handed to onClick, which decides whether to navigate or preview.
export const SearchTab = ({ text, to, onClick, isActive }) => (
    <Link
        to={to}
        className={cn("px-4 py-2 text-cm-p-text-primary text-base bg-transparent h-11 border-b-2 border-b-transparent", {
            "border-b-cm-p-accent font-medium": isActive,
        })}
        onClick={(e) => {
            if (isModifiedClick(e)) return;
            onClick?.(e);
        }}
    >
        {text}
    </Link>
);
